<template>
	<div>
		<p class="label-color">{{ label }}</p>
		<div
			:class="isEnter ? 'drop-area enter pa-2' : 'drop-area pa-2'"
			@dragenter="dragEnter"
			@dragleave="dragLeave"
			@dragover.prevent
			@drop.prevent="dropFile"
		>
			<v-file-input
				label="ここにファイルをドラッグ＆ドロップ（最大容量:10MB/ファイル）"
				multiple
				v-model="newFiles"
				@change="addFiles"
			/>
		</div>
		<div v-if="files.length > 0">
			<v-row no-gutters class="pa-2" v-for="(file, index) in files" :key="'file-' + index">
				<v-icon>mdi-file-upload-outline</v-icon>
				{{ file.name }}
				<v-icon class="ml-2" @click="deleteFile(index)">mdi-close</v-icon>
			</v-row>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		label: "",
		targetIndex: "",
		attached_files: {
			type: Array,
			default: false,
			required: () => [],
		},
	},
	data() {
		return {
			isEnter: false,
			files: [],
			newFiles: [],
		}
	},
	mounted() {
		this.files = this.attached_files
	},
	methods: {
		dragEnter() {
			this.isEnter = true
		},
		dragLeave() {
			this.isEnter = false
		},
		dropFile() {
			this.files.push([...event.dataTransfer.files])
			this.files = this.files.flat()
			this.$emit("fileShare", this.files, this.targetIndex)
			this.isEnter = false
		},
		deleteFile(index) {
			this.files.splice(index, 1)
			this.$emit("fileShare", this.files, this.targetIndex)
		},
		addFiles() {
			if (!this.newFiles.length) return
			this.files.push(this.newFiles)
			this.files = this.files.flat()
			this.$emit("fileShare", this.files, this.targetIndex)
			this.isEnter = false
			this.newFiles = []
		},
		resetFiles() {
			this.isEnter = false
			this.files = []
			this.newFiles = []
		},
	},
}
</script>

<style scoped>
.drop-area {
	color: gray;
	font-weight: bold;
	font-size: 1.2em;
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	align-items: center;
	width: 100%;
	height: 140px;
	border: 2px solid gray;
	border-radius: 15px;
}
.enter {
	border: 2px dashed gray;
}
.label-color {
	color: rgba(0, 0, 0, 0.87);
}
</style>
